import classNames from "classnames";

import CustomerPay from "../../components/wallet/CustomerPay";
import RefundBuyer from "../../components/wallet/RefundBuyer";
import ReleaseToSeller from "../../components/wallet/ReleaseToSeller";
import { USER_ROLE } from "../../enums";
import { LOCALIZE_DATE } from "../../setup/constants";
import { AuthConfig } from "../../setup/context/config/authConfig";
import { walletsTypes } from "./constants";
import styles from "./wallet.module.scss";

export const options: any = {
  weekday: "long",
  year: "numeric",
  month: "long",
  day: "numeric",
};

const TransactionsList = (props: any) => {
  const { transactionsInfo } = props;

  const checkViewForTransBuyer = () => {
    switch (transactionsInfo.transactionType) {
      case walletsTypes.CUSTOMER_PAY:
        return (
          <CustomerPay
            type={USER_ROLE.BUYER}
            transactionsInfo={transactionsInfo}
          />
        );
      case walletsTypes.RELEASE_TO_PROVIDER:
      case walletsTypes.CLOSE_RELEASE_TO_PROVIDER:
        return (
          <ReleaseToSeller
            type={USER_ROLE.BUYER}
            transactionsInfo={transactionsInfo}
          />
        );
      case walletsTypes.REFUND_CUSTOMER:
        return (
          <RefundBuyer
            type={USER_ROLE.BUYER}
            transactionsInfo={transactionsInfo}
          />
        );

      default:
        return;
    }
  };

  const checkViewForTransSeller = () => {
    switch (transactionsInfo.transactionType) {
      case walletsTypes.CUSTOMER_PAY:
        return (
          <CustomerPay
            type={USER_ROLE.SELLER}
            transactionsInfo={transactionsInfo}
          />
        );
      case walletsTypes.RELEASE_TO_PROVIDER:
      case walletsTypes.CLOSE_RELEASE_TO_PROVIDER:
        return (
          <ReleaseToSeller
            type={USER_ROLE.SELLER}
            transactionsInfo={transactionsInfo}
          />
        );
      case walletsTypes.REFUND_CUSTOMER:
        return (
          <RefundBuyer
            type={USER_ROLE.SELLER}
            transactionsInfo={transactionsInfo}
          />
        );
      default:
        return;
    }
  };

  const userId = AuthConfig?.getUserInfo()?.id;

  return (
    <div className={classNames(styles["transItemContainer"], "card")}>
      {userId == transactionsInfo.otherUserId
        ? checkViewForTransBuyer()
        : checkViewForTransSeller()}
      <div className={styles["date_contianer"]}>
        <p className={"hint2"}>
          {new Date(transactionsInfo.createdAt).toLocaleDateString(
            LOCALIZE_DATE,
            options
          )}
        </p>
      </div>
    </div>
  );
};
export default TransactionsList;
